var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.ready
        ? _c("p", [
            _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
            _vm._v(" Please wait, we are preparing the graph.\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("alert", { attrs: { type: "danger" } }, [
            _vm._v(
              "\n        There was an error with the graph. Please try again later\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "vis-canvas", attrs: { id: _vm.id } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }